import { entries, isNil, join, map, pipe, reject } from '@fxts/core';

/**
 * 객체를 URL 쿼리스트링으로 변환합니다.
 * @param query - 쿼리스트링으로 변환할 객체
 * @example
 * makeQueryString({ name: '홍길동', age: '20' }) // 'name=홍길동&age=20'
 * makeQueryString({ name: '홍길동', age: null }) // 'name=홍길동'
 * makeQueryString({}) // ''
 * @returns 생성된 쿼리스트링
 */
export const makeQueryString = (query: Record<string, any>): string =>
  pipe(
    query,
    entries,
    reject(([, v]) => isNil(v)),
    map(([k, v]) => {
      const value = typeof v === 'object' ? encodeURIComponent(JSON.stringify(v)) : encodeURIComponent(v);
      return `${k}=${value}`;
    }),
    join('&'),
  );
